<template>
  <v-text-field
    outlined
    dense
    hide-details
    :clearable="clearable"
    :prepend-inner-icon="searchIcon"
    :label="label"
    ss="pb-0 mb-0"
    :value="localValue"
    @input="onChange($event)"
    v-bind="$attrs"
  />
</template>

<script>
import { debounce } from 'lodash';

export default {
  props: {
    value: String,
    label: {
      type: String,
      default: 'Faça uma busca',
    },
    searchIcon: {
      type: String,
      default: 'mdi-magnify',
    },
    clearable: {
      type: Boolean,
      default: true,
    },
    onSearch: {
      type: Function,
    },
  },
  data() {
    return {
      debounce: null,
    };
  },
  computed: {
    localValue: {
      get() { return this.value; },
    },
  },
  methods: {
    onChange(value) {
      this.debounce(value);
    },
    onChangeValue(value) {
      this.$emit('input', value);
      if (this.onSearch) {
        this.onSearch(value);
      }
    },
  },
  created() {
    this.debounce = debounce(this.onChangeValue, 500);
  },
};
</script>
